"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function () {
  return {
    formRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row',
      fallbacks: [{
        display: '-ms-flexbox',
        '-ms-flex-align': 'center',
        '-ms-flex-pack': 'justify',
        '-ms-flex-direction': 'row'
      }, {
        display: '-webkit-box',
        '-webkit-box-align': 'center',
        '-webkit-box-pack': 'justify',
        '-webkit-box-orient': 'horizontal',
        '-webkit-box-direction': 'normal'
      }, {
        display: '-webkit-flex',
        '-webkit-align-items': 'center',
        '-webkit-justify-content': 'space-between',
        '-webkit-flex-direction': 'row'
      }]
    },
    compact: {}
  };
};